import Vue from 'vue';
import { State } from 'vuex-simple';
import { computed, reactive } from 'vue';

type IApplicationData = object;

class BizApiStorage {
	public state: Common.IMap<IApplicationData> = reactive({});

	@State()
	public set = (key: string, value: object = {}) => {
		if (typeof value !== 'object') {
			value = reactive(value);
		}

		Vue.set(this.state, key, value);
	};

	@State()
	public get = (key: string) => {
		!this.state[key] && this.set(key, {});

		return this.state[key];
	};

	@State()
	public remove = (key: string) => {
		this.set(key, undefined);
	};

	@State()
	public use = (key: string) => {
		!this.state[key] && this.set(key, {});

		return computed(() => {
			return this.state[key];
		});
	};
}

const bizApiStorage = new BizApiStorage();

export default bizApiStorage;
